export default __webpack_public_path__ + "static/media/FruitTreePruning.e135c9ee.jpg";